<template>
  <div>
    <details :open="props.open">
      <summary class="relative pl-6 transition-all duration-300 ease-in-out details-summary dark:text-zinc-300">
        {{ props.summary }}
      </summary>
      <div class="pl-6">
        <slot />
      </div>
    </details>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  summary: string;
  open?: boolean;
}

const props = defineProps<Props>();
</script>

<style scoped>
summary {
  display: block;
  cursor: pointer;
  outline: 0;
}

summary::-webkit-details-marker {
  display: none;
}

.details-summary::before {
  position: absolute;
  display: block;
  content: '';
  width: 1.5rem;
  height: 1.5rem;
  left: 0;
  top: 0;
  /* transform: translateY(-50%); */
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjgyOTkgMTEuMjg5N0wxMC41ODk5IDcuMDQ5N0MxMC40OTcgNi45NTU5OCAxMC4zODY0IDYuODgxNTggMTAuMjY0NSA2LjgzMDgxQzEwLjE0MjcgNi43ODAwNCAxMC4wMTIgNi43NTM5MSA5Ljg3OTk0IDYuNzUzOTFDOS43NDc5MyA2Ljc1MzkxIDkuNjE3MjMgNi43ODAwNCA5LjQ5NTM3IDYuODMwODFDOS4zNzM1MSA2Ljg4MTU4IDkuMjYyOTEgNi45NTU5OCA5LjE2OTk0IDcuMDQ5N0M4Ljk4MzY5IDcuMjM3MDcgOC44NzkxNSA3LjQ5MDUyIDguODc5MTUgNy43NTQ3QzguODc5MTUgOC4wMTg4OSA4Ljk4MzY5IDguMjcyMzQgOS4xNjk5NCA4LjQ1OTdMMTIuNzA5OSAxMS45OTk3TDkuMTY5OTQgMTUuNTM5N0M4Ljk4MzY5IDE1LjcyNzEgOC44NzkxNSAxNS45ODA1IDguODc5MTUgMTYuMjQ0N0M4Ljg3OTE1IDE2LjUwODkgOC45ODM2OSAxNi43NjIzIDkuMTY5OTQgMTYuOTQ5N0M5LjI2MzM4IDE3LjA0MjQgOS4zNzQyIDE3LjExNTcgOS40OTYwNCAxNy4xNjU1QzkuNjE3ODcgMTcuMjE1MiA5Ljc0ODM0IDE3LjI0MDUgOS44Nzk5NCAxNy4yMzk3QzEwLjAxMTUgMTcuMjQwNSAxMC4xNDIgMTcuMjE1MiAxMC4yNjM4IDE3LjE2NTVDMTAuMzg1NyAxNy4xMTU3IDEwLjQ5NjUgMTcuMDQyNCAxMC41ODk5IDE2Ljk0OTdMMTQuODI5OSAxMi43MDk3QzE0LjkyMzcgMTIuNjE2NyAxNC45OTgxIDEyLjUwNjEgMTUuMDQ4OCAxMi4zODQzQzE1LjA5OTYgMTIuMjYyNCAxNS4xMjU3IDEyLjEzMTcgMTUuMTI1NyAxMS45OTk3QzE1LjEyNTcgMTEuODY3NyAxNS4wOTk2IDExLjczNyAxNS4wNDg4IDExLjYxNTFDMTQuOTk4MSAxMS40OTMzIDE0LjkyMzcgMTEuMzgyNyAxNC44Mjk5IDExLjI4OTdaIiBmaWxsPSIjMjEyNTI5Ii8+Cjwvc3ZnPgo=');
}
details[open] > .details-summary::before {
  transform: rotate(90deg);
}

.toggle-switch::after {
  @apply w-3 h-3 content-[''] bg-white rounded-full absolute top-1 left-1;
}
.toggle-switch:checked {
  @apply bg-blue-500;
}
.toggle-switch:checked::after {
  @apply left-auto right-1;
}
</style>
